module.exports = __webpack_public_path__ + "static/media/agent-button.1e1c479e.png";